import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PaginationComponent } from "../../../../components/pagination/pagination.component";
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { CascadingSelectServiceService } from '../../../services/cascading-select-service.service';
import { map } from 'lodash';
import { FormBuilder, FormGroup } from '@angular/forms';
import { group } from '@angular/animations';
import { CommunicationApiService } from '../../communication-api.service';
import { FilterBaseAccessService } from '../../../../auth/filterbase-access';

@Component({
  selector: 'app-messages',
  standalone: true,
  imports: [CommonModule, PaginationComponent, RouterModule, CommonModule, ],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.css'
})
export class MessagesComponent {
  isCreateMessageVisible = false;
  isInboxview = false;

  tabs = [
    {
      "id": 1,
      "label": "All",
      "identifier": "all",
      "count": 5219
    },
    {
      "id": 2,
      "label": "Sent",
      "identifier": "sent",
      "count": 3473
    },
    {
      "id": 3,
      "label": "Scheduled",
      "identifier": "scheduled",
      "count": 573
    },
    {
      "id": 4,
      "label": "Draft",
      "identifier": "draft",
      "count": 73
    },
    {
      "id": 5,
      "label": "Email",
      "identifier": "email",
      "count": 3473
    },
    {
      "id": 6,
      "label": "SMS",
      "identifier": "sms",
      "count": 573
    },
    {
      "id": 7,
      "label": "Push Notification",
      "identifier": "push_notification",
      "count": 73
    }
  ]
  currentTab = 'sent'

  inboxList = [
    {
      "id": 1,
      "title": "Welcome to Our Platform",
      "message": "Thank you for signing up with us! We're thrilled to have you on board. Our platform is designed to help you manage your tasks efficiently and stay ahead. If you have any questions, feel free to contact our support team anytime.",
      "type": "email",
      "date": "2025-07-18T08:15:00Z"
    },
    {
      "id": 2,
      "title": "Account Verified",
      "message": "Good news! Your email address has been successfully verified. You now have full access to all features and can start using our services without restrictions. Stay tuned for more updates and tips in your inbox.",
      "type": "email",
      "date": "2025-07-18T09:00:00Z"
    },
    {
      "id": 3,
      "title": "Promo Offer",
      "message": "We're excited to offer you an exclusive 20% discount on your next purchase. This offer is valid until the end of the week, so don't miss out! Just use the code 'SAVE20' during checkout. Happy shopping!",
      "type": "sms",
      "date": "2025-07-17T17:45:00Z"
    },
    {
      "id": 4,
      "title": "Security Alert",
      "message": "We detected a login attempt from an unfamiliar device. If this was you, you can ignore this message. If not, we recommend changing your password immediately and reviewing your account activity.",
      "type": "notification",
      "date": "2025-07-17T15:20:00Z"
    },
    {
      "id": 5,
      "title": "Order Shipped",
      "message": "Your order #4567 has been shipped! You can track its progress via the tracking number provided in your account. Estimated delivery is within 3-5 business days. Thank you for shopping with us.",
      "type": "email",
      "date": "2025-07-16T14:30:00Z"
    },
    {
      "id": 6,
      "title": "System Maintenance",
      "message": "Please note that we will be performing scheduled maintenance on July 20th from 2 AM to 4 AM IST. During this time, some features may be temporarily unavailable. We apologize for any inconvenience caused.",
      "type": "notification",
      "date": "2025-07-16T10:10:00Z"
    },
    {
      "id": 7,
      "title": "Payment Received",
      "message": "We’ve successfully received your payment of ₹1,299 for your recent transaction. A receipt has been sent to your registered email address. You can also view it in your account under the 'Billing' section.",
      "type": "sms",
      "date": "2025-07-15T18:00:00Z"
    },
    {
      "id": 8,
      "title": "Weekly Newsletter",
      "message": "Here’s your weekly roundup of the most important updates, articles, and tips from our team. Learn how to make the most of your account and explore our newly launched features and tools.",
      "type": "email",
      "date": "2025-07-15T08:00:00Z"
    },
    {
      "id": 9,
      "title": "New Feature Unlocked",
      "message": "Congratulations! You now have access to our new analytics dashboard. Monitor your progress, gain insights from your activity, and make better data-driven decisions starting today.",
      "type": "notification",
      "date": "2025-07-14T16:40:00Z"
    },
    {
      "id": 10,
      "title": "Delivery Scheduled",
      "message": "Your package is scheduled for delivery on July 19th between 10 AM and 12 PM. Please ensure someone is available to receive it. You can reschedule or add delivery instructions from your orders page.",
      "type": "sms",
      "date": "2025-07-14T12:30:00Z"
    }
  ]

  academicEntries$!: Observable<any>
  departments: any[] = [];
  classes: any[] = [];
  batches: any[] = [];
  serachFieldsForm!: FormGroup
  messages:any[] = []

  paginationData: any = {};
  currentPage: any = '';

  constructor(access:FilterBaseAccessService,private cascadService: CascadingSelectServiceService,private fb: FormBuilder,private communicationApiService: CommunicationApiService) {
    this.isCreateMessageVisible = access.checkaccessforfiltersandactions('create message')
    this.isInboxview = access.checkaccessforfiltersandactions('communication messages')
    this.academicEntries$ = this.cascadService.academicEntries$
    this.academicEntries$.subscribe((data: any) => this.departments = data.data)

    this.serachFieldsForm = this.fb.group({
      department: [''],
      class: [''],
      batch: [''],
      course:[''],
      academic_year: [''],
      group: [''],
      search: ['']
    })

    this.getData()

  }

  setFields(e: any, type: string) {
    const value = +e.target.value;
    if (type === 'department') {
      const matched = this.departments.find(entry => entry.id === value);
      this.classes = matched?.classes || [];
      this.batches = [];
    }
    if (type === 'class') {
      const matched = this.classes.find(entry => entry.id === value);
      this.batches = matched?.batches || [];
    }
  }

  getData() {
    this.communicationApiService.getMessages(this.currentPage, this.serachFieldsForm.value).subscribe({
      next: (res: any) => {
        this.messages = res.data;
        this.paginationData = res.meta;
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }



}
